import { render } from "./HeroiconsOutlineCalculator.vue?vue&type=template&id=cba9bb34"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCalculator.vue"]])

export default __exports__